import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventDefault]',
})
export class PreventDefaultDirective {
  @HostListener('click', ['$event'])
  click(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
